export const parentCategoriesListKey = () => ["parent-categories-list"];

export const parentCategoriesListParamsKey = ({ queryParams }) => [
  ...parentCategoriesListKey(),
  queryParams,
];
